import React, { useState, useEffect } from 'react';
import PageHeader from '../../components/pageHeader/PageHeader';
import { Dropdown, Radio, Row, Spin } from 'antd';
import { Breadcrumb, Layout, Menu, Pagination } from 'antd';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import ListCourseCard from '../../components/listCourseCard/ListCourseCard';
import { UnorderedListOutlined, AppstoreOutlined, HistoryOutlined, DownOutlined } from '@ant-design/icons';
import Sider from 'antd/es/layout/Sider';
import useGetApi from '../../services/useGetApi';
import CourseGridCard from '../../components/courseGridCard/CourseGridCard';
import { Helmet } from 'react-helmet';

const { Content } = Layout;
const COURSES_PER_PAGE = 10;

const Courses = () => {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('keyword');
  const [categoryId, setCategoryId] = useState('');
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();


  const [isLoading, error, coursesData, getData] = useGetApi(`course/getAll?page=0&size=10&sort=id&sort=asc`, [], true);
  const [isLoadingCategories, categoriesError, categories, getCategories] = 
    useGetApi(`category/getAll?page=0&size=10&sort=id&sort=asc`, [], true);
  const [isLoadingFilterCourses, filterCoursesError, filterCourses, getFilterCourses] = 
    useGetApi(``, [], true);
  

  const [currentPage, setCurrentPage] = useState(0);
  const [currentFilteredPage, setCurrentFilteredPage] = useState(0);
  

  const [filteredCourses, setFilteredCourses] = useState([]);
  const [displayCourses, setDisplayCourses] = useState([]);
  

  const [category, setCategory] = useState('all');
  const [courseView, setCourseView] = useState(true);


  useEffect(() => {
    getData(`course/getAll?page=${currentPage}&size=10&sort=id&sort=asc`);
    getCategories(`category/getAll?page=0&size=999&sort=id&sort=asc`);
  }, []);


  useEffect(() => {
    if (!isFiltered) {
      getData(`course/getAll?page=${currentPage}&size=10&sort=id&sort=asc`);
    }
  }, [currentPage]);


  useEffect(() => {
    if (isFiltered) {
      const startIndex = currentFilteredPage * COURSES_PER_PAGE;
      setDisplayCourses(filteredCourses.slice(startIndex, startIndex + COURSES_PER_PAGE));
    } else {
      setDisplayCourses(coursesData?.content || []);
    }
  }, [isFiltered, filteredCourses, currentFilteredPage, coursesData]);

  // Handle category filtering
  const handleCategoryChange = async (eduCategory) => {
    if (eduCategory === 'all') {
      setCategory('all');
      setCategoryId('');
      setIsFiltered(false);
      setCurrentPage(0);
      getData(`course/getAll?page=0&size=10&sort=id&sort=asc`);
    } else {
      setCategory(eduCategory.id);
      setCategoryId(eduCategory.id);
      setSubCategoryId(eduCategory.parent);
      setIsFiltered(true);
      setCurrentFilteredPage(0);
    }
  };

  // Fetch filtered courses
  const categoryChangeApiCall = async () => {
    if (categoryId) {
      const response = await getFilterCourses(
        `course/query?categoryId=${categoryId}&subCategoryId=&level=&language=`
      );
      setFilteredCourses(response || []);
    }
  };

  useEffect(() => {
    // console.log(categoryId,'category')
    if (categoryId) {
      categoryChangeApiCall();
    }
  }, [categoryId, subCategoryId]);

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [currentPage, currentFilteredPage]);

  // View toggle functions
  const coursesViewinList = () => setCourseView(true);
  const courseViewinGrid = () => setCourseView(false);
  const reloadPage = () => window.location.reload();

  if (isLoadingCategories) {
    return <Spin tip="Loading..." delay={300}/>;
  }

 

  const menu = (
    <Menu >
      <Menu.ItemGroup title="Categories" style={{marginTop:'10px'}}>
        {categories?.content?.map((eduCategory) => (
          <Menu.Item key={eduCategory.id} onClick={() =>handleCategoryChange(eduCategory)}>
            {eduCategory.name}
          </Menu.Item>
        ))}
      </Menu.ItemGroup>
    </Menu>
  );

  const breadcrumbItems = [
    {
      title: (
        <Dropdown overlay={menu} trigger={['click']} >
          <a onClick={(e) => e.preventDefault()} style={{border:"1px solid grey",marginTop:"10px"}}>
          {/* <UnorderedListOutlined style={{ marginRight: 4 }} /> */}
          <span style={{marginTop:"-50px"}}>Categories</span>
          <DownOutlined style={{ marginLeft: 4 }} />
        </a>
        </Dropdown>
      ),
      key: 'dropdown',
    },

  ];


  return (
    <div>
      <Helmet>
        <title>Courses | LMS</title>
      </Helmet>
      <PageHeader title={'Courses'} />
      <div className="courses_main">
        <Layout>
          <Sider trigger={null} collapsible style={{ height: 'auto', position: 'sticky' }} theme='light' className='desktop-nav'>
            <Menu theme="light" mode="inline" selectedKeys={[location.pathname]}>
              <span className="tag">Categories</span>
              <Row style={{ marginTop: '20px' }}>
                <Menu.Item key="all">
                  <Radio 
                    value="all" 
                    checked={category === 'all'} 
                    onChange={() => handleCategoryChange('all')}
                  >
                    All
                  </Radio>
                </Menu.Item>
                
                {Array.isArray(categories?.content) && categories.content.map((eduCategory) => (
                  <Menu.Item key={eduCategory.id}>
                    <Radio
                      value={eduCategory.id}
                      checked={category === eduCategory.id}
                      onChange={() => handleCategoryChange(eduCategory)}
                    >
                      {eduCategory.name}
                    </Radio>
                  </Menu.Item>
                ))}
              </Row>
            </Menu>
          </Sider>

          <Layout style={{ paddingLeft: '30px', backgroundColor: 'white' }}>
            <Breadcrumb
              items={[
                { title: <p onClick={coursesViewinList}><UnorderedListOutlined className="cursor-pointer" /></p> },
                { title: <p onClick={courseViewinGrid}><AppstoreOutlined className="cursor-pointer" /></p> },
                { title: <p onClick={reloadPage}><HistoryOutlined className="cursor-pointer" /></p> },
              ]}
              style={{ marginTop: '10px' }}
              className='desktop-nav'
            />
            <Breadcrumb
              items={breadcrumbItems}
              className='bread_crumb'
            />
            <Content style={{ marginTop: 10 }}>
              {courseView ? (
                <div>
                  {displayCourses.length > 0 ? (
                    displayCourses.map((course) => (
                      <ListCourseCard key={course.id} course={course} />
                    ))
                  ) : (
                    <p>No courses found</p>
                  )}
                </div>
              ) : (
                <div className='grid_card_view'>
                  {displayCourses.length > 0 ? (
                    displayCourses.map((course) => (
                      <div key={course.id}>
                        <CourseGridCard course={course} />
                      </div>
                    ))
                  ) : (
                    <p>No courses found</p>
                  )}
                </div>
              )}

              <Pagination
                current={isFiltered ? currentFilteredPage + 1 : currentPage + 1}
                pageSize={COURSES_PER_PAGE}
                total={isFiltered ? filteredCourses.length : coursesData?.totalElements || 0}
                onChange={(page) => {
                  if (isFiltered) {
                    setCurrentFilteredPage(page - 1);
                  } else {
                    setCurrentPage(page - 1);
                  }
                }}
                showSizeChanger={false}
                style={{ marginTop: '20px', textAlign: 'center' }}
              />
            </Content>
          </Layout>
        </Layout>
      </div>
    </div>
  );
};

export default Courses;